import { render, staticRenderFns } from "./SelectSupplierBadge.vue?vue&type=template&id=2ca34c3a&"
import script from "./SelectSupplierBadge.vue?vue&type=script&lang=js&"
export * from "./SelectSupplierBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports